module.exports = __webpack_public_path__ + "static/img/20260905-04.f3ab476.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/20260905-04.webp
// module id = kEY1
// module chunks = 1